import React, { useEffect, useState } from "react";
import { WifiOutlined, InfoOutlined, WarningFilled } from "@ant-design/icons";
import {Row, Col} from 'antd';

import "../../styles/App.css";

export const Offline = () => {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [online]);

  return (
    <div className="containerr">
      {online ? (
        <div className="online">
        <Row justify="center" align="middle">
          <Col xs={24} sm={20} md={16} lg={12} xl={8}>
            <div style={{ textAlign: "center" }}>
              <h1>
                <WifiOutlined /> Internet connection restored
              </h1>
            </div>
          </Col>
        </Row>
      </div>
      ) : (
        <div className="offline">
          <Row justify="center" align="middle">
            <Col xs={24} sm={20} md={16} lg={12} xl={8}>
              <div style={{ textAlign: "center" }}>
                <h1>
                  <WarningFilled />
                  You are offline!
                </h1>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

// export default Offline;
